function whichTransitionEvent(){
  var t,
      el = document.createElement("fakeelement");

  var transitions = {
    "transition"      : "transitionend",
    "OTransition"     : "oTransitionEnd",
    "MozTransition"   : "transitionend",
    "WebkitTransition": "webkitTransitionEnd"
  }

  for (t in transitions){
    if (el.style[t] !== undefined){
      return transitions[t];
    }
  }
}

var transitionEvent = whichTransitionEvent();

  

//animate frontpage hero
var hero = $('.indexPageBanner');
var marketLeader = $('.marketLeader');
function animateHero(){
    if(!hero.hasClass('loaded')){
        hero.addClass('loaded');
    }
}

    animateHero();
    hero.one(transitionEvent,function(event) {
        if(!marketLeader.hasClass('active')){
            marketLeader.addClass('active');
        }
  });
$( document ).ready(function() {
});

//Make scrollbar modals
if (!$('body').hasClass("ie")) {
    var Height2 = $(window).height();
    var ModalHeight = (Height2 - 120);
    $('.modal-body').addClass('overflowModal');
    $('.modal-body').css('max-height', ModalHeight);
}
//IE8 MENU FIX! -OPEN, CLOSE
if ($('body').hasClass("ie")) {
    $('#dl-menu1-button').click(function() {
        if ($('.menu1').hasClass("open")) {
            $('.menu1').removeClass('open').addClass('closed');
        } else {
            // if other menus are open remove open class and add closed
            $('.menu1').removeClass('closed').addClass('open');
        }
    });
    $('#dl-menu2-button').click(function() {
        if ($('.menu2').hasClass("open")) {
            $('.menu2').removeClass('open').addClass('closed');
        } else {
            // if other menus are open remove open class and add closed
            $('.menu2').removeClass('closed').addClass('open');
        }
    });
    $(".bar").each(function() {
        var length = $(this).find("span").html();
        $(this).find(".slideup").delay(500).animate({
            'height': length
        }, "slow", function() {
            $(this).find("span").fadeIn(1000);
        });
    });
}
//IE9 MENU FIX - Z-INDEX
$('#dl-menu1-button').click(function() {
    if ($('.topbanner').hasClass("zTop")) {
        $('.topbanner').removeClass('zTop').addClass('zBottom');
    } else if ($('.menu2').hasClass("dl-menuopen")) {
        $('.topbanner').addClass('zBottom');
    } else {
        // if other menus are open remove open class and add closed
        $('.topbanner').removeClass('zBottom').addClass('zTop');
    }
});
$('#dl-menu2-button').click(function() {
    if ($('.topbanner').hasClass("zTop")) {
        $('.topbanner').removeClass('zTop').addClass('zBottom');

    } else if ($('.menu1').hasClass("dl-menuopen")) {
        $('.topbanner').addClass('zBottom');
    } else {
        // if other menus are open remove open class and add closed
        $('.topbanner').removeClass('zBottom').addClass('zTop');
    }
});
$('a[href=".#concept"]').click(function() {
    $('#dl-menu1').dlmenu("closeMenu");
    if ($('.topbanner').hasClass("zTop")) {
        $('.topbanner').removeClass('zTop').addClass('zBottom');
    } else if ($('.menu2').hasClass("dl-menuopen")) {
        $('.topbanner').addClass('zBottom');
    } else {
        // if other menus are open remove open class and add closed
        $('.topbanner').removeClass('zBottom').addClass('zTop');
    }
});
$('a[href=".#defgoFunctions"]').click(function() {
    $('#dl-menu1').dlmenu("closeMenu");
    if ($('.topbanner').hasClass("zTop")) {
        $('.topbanner').removeClass('zTop').addClass('zBottom');
    } else if ($('.menu2').hasClass("dl-menuopen")) {
        $('.topbanner').addClass('zBottom');
    } else {
        // if other menus are open remove open class and add closed
        $('.topbanner').removeClass('zBottom').addClass('zTop');
    }
});
$('a[href="#contact"]').click(function() {
    $('#dl-menu1').dlmenu("closeMenu");
    if ($('.topbanner').hasClass("zTop")) {
        $('.topbanner').removeClass('zTop').addClass('zBottom');
    } else if ($('.menu2').hasClass("dl-menuopen")) {
        $('.topbanner').addClass('zBottom');
    } else {
        // if other menus are open remove open class and add closed
        $('.topbanner').removeClass('zBottom').addClass('zTop');
    }
});
$('a[href="#support"]').click(function() {
    $('#dl-menu1').dlmenu("closeMenu");
    if ($('.topbanner').hasClass("zTop")) {
        $('.topbanner').removeClass('zTop').addClass('zBottom');
    } else if ($('.menu2').hasClass("dl-menuopen")) {
        $('.topbanner').addClass('zBottom');
    } else {
        // if other menus are open remove open class and add closed
        $('.topbanner').removeClass('zBottom').addClass('zTop');
    }
});
$('a[href=".#why"]').click(function() {
    $('#dl-menu1').dlmenu("closeMenu");
    if ($('.topbanner').hasClass("zTop")) {
        $('.topbanner').removeClass('zTop').addClass('zBottom');
    } else if ($('.menu2').hasClass("dl-menuopen")) {
        $('.topbanner').addClass('zBottom');
    } else {
        // if other menus are open remove open class and add closed
        $('.topbanner').removeClass('zBottom').addClass('zTop');
    }
});
//IE INPUT OG ANIMATE STILL FIX
if ($('body').hasClass("ie-9")) {
    $('.innerAnimate img').css('opacity', '1');
    $('.surveyIMG').css('opacity', '1');
    $('input[type="text"]').css('padding', '0 12px');
    $('input[type="email"]').css('padding', '0 12px');
}
//Launch PDF
$('#launchExpo').on('click', function(event) {
    window.open("assets/pdf/EXPO2010.pdf", "Expo2010 case");
});
$('#launchFSB').on('click', function(event) {
    window.open("assets/pdf/fsb.pdf", "FSB case");
});
$('#launchC3').on('click', function(event) {
    window.open("assets/pdf/C3.pdf", "C3 case");
});
//Launch country modal
$('.launchCountries').on('click', function(event) {
    event.preventDefault();
    $('#CountriesModal').modal('toggle')
});
//Slide to top button
$(window).scroll(function() {
    if ($(window).scrollTop() >= 450) {
        $(".totop").fadeIn("slow");
        //Otherwise remove inline styles and thereby revert to original stying
    } else {
        $(".totop").fadeOut("slow");
    }
});
if (!$('#indexID').hasClass('indexPage')) {
    $(".subMenu1").removeAttr("href");
    $(".subMenu2").removeAttr("href")
    $(".subMenu3").removeAttr("href")
    $(".footerLink").removeAttr("href")
    $('.footerLink').on('click', function(event) {
        window.location.href = ".#concept"; //Concept
    });
    $('.subMenu1').on('click', function(event) {
        window.location.href = ".#why"; //Why defgo
    });
    $('.subMenu2').on('click', function(event) {
        window.location.href = ".#defgoFunctions"; //Defgo functions
    });
    $('.subMenu3').on('click', function(event) {
        window.location.href = ".#concept"; // defgo Concept
    });
}
//Slide to anchor
$('a[href*=#]').on('click', function(event) {
    event.preventDefault();
    $('html,body').animate({
        scrollTop: $(this.hash).offset().top
    }, 500);
});
//Tooltip defgo Products
$('.popoverCustom').popover({
    trigger: "hover"
});
//Make company logo's at bottom
function bannerHeight() {
    Height = $(window).height();
    FinalHeight = (Height - 75);
    $('#indexBanner').css('height', FinalHeight);
    if (FinalHeight < 570) {
        $('#indexBanner').css('padding-top', '30px');
    }
    if ($('#indexID').hasClass("indexPage")) {
        //Bar chart animation on scroll
        $(window).on("scroll", function() {
            var scrollPosition = window.scrollY || window.pageYOffset;
            if (scrollPosition > $("#why").position().top - $(window).height()) {
                $(".bar").each(function() {
                    var length = $(this).find("span").html();
                    $(this).find(".slideup").delay(500).animate({
                        'height': length
                    }, "slow", function() {
                        $(this).find("span").fadeIn(1000);
                    });
                });
            }
        });
    }
}

$( window ).resize(function() {
  bannerHeight();
});
//Check if Radio student is checked
$('#createAccount').click(function() {
    if ($('#checkboxStudent').is(':checked')) {
        $('#FreeTrialModal').modal('hide')
        $('#StudentSignUp').modal('toggle')
    } else {
        $("#CheckifStudent").submit()
    }
});
//open modal from Defgo
$(document).ready(function() {
  bannerHeight();
    if (window.location.search.indexOf("signup") > -1) {
        $('#FreeTrialModal').modal('toggle')
    }
    if (window.location.search.indexOf("student") > -1) {
        $('#StudentSignUp').modal('toggle')
    }
    if (window.location.search.indexOf("?defgo1") > -1) {
        $('#defgo1Modal').modal('toggle')
    }

});
// $('a.link').click(function() {
//     event.preventDefault();
//         var theHref = $(this).attr('href');      
//         window.location.replace(theHref);
// });
//Online chat script
// You could specify any links for online and offline chat icons here
function openMessenger() {
    if (isOnlineSupportAvailable) {
        var url = 'https://messenger.providesupport.com/messenger/interresearch.html';
        window.open(url, '_blank', 'menubar=0,location=0,scrollbars=auto,resizable=1,status=0,width=600,height=620');
    } else {
        /*alert( 'Onlinesupport er ikke tilgængelig i øjeblikket' )*/
        $('#noChat').modal('toggle')
    }
}
var checkImg = new Image();
checkImg.onload = checkImgOnload;
isOnlineSupportAvailable = false;
var body = $('body');
if(body.hasClass('uk')){
    console.log('uk');
    var offlineText = "<span>The chat is offline</span>";
    var onlineText = "<span>The chat is online</span>";
}
else if(body.hasClass('es')){
    console.log('es');
    var offlineText = "<span>El chat está fuera de línea</span>";
    var onlineText = "<span>El chat está en línea</span>";   
}else if(body.hasClass('ru')){
    console.log('ru');
    var offlineText = "<span>Чат отключен</span>";
    var onlineText = "<span>Чат включен</span>";   
}
else{
    var offlineText = "<span>Chatten er offline</span>";
    var onlineText = "<span>Chatten er online</span>";
}
function checkImgOnload() {
    var d = document.getElementById("ps_chat_link");
    if (d != null) {
        var w = checkImg.width;
        if (w == 2) {
            isOnlineSupportAvailable = true;
            $('#ps_chat_link').css('background-color', '#02b1e8;');
            $('#ps_chat_link').css('border-color', '#02b1e8');
            $("#ps_chat_link").hover(function() {
                $(this).css('color', '#02b1e8');
                $(this).css('background-color', '#fff');
            });
            d.innerHTML = onlineText;
        } else {
            isOnlineSupportAvailable = false;
            $('#ps_chat_link').css('background-color', 'grey');
            $('#ps_chat_link').css('border-color', 'grey');
            $("#ps_chat_link").hover(function() {
                $(this).css('color', 'white');
            });
            d.innerHTML = offlineText;
        }
    }
}

function refreshLink() {
    setTimeout("refreshLink()", 20000);
    checkImg.src = "https://image.providesupport.com/online-presence-image/interresearch?t=" + (new Date()).getTime();
}
refreshLink();
//Defgo Login
function openwindow4(url, height, width, windowname) {
    var w = screen.availWidth || screen.width
    var h = screen.availHeight || screen.height
    w = w - 12
    h = h - 70
    defgonet = window.open(url, windowname, 'toolbar=no,location=no,directories=no,status=yes,menubar=no,scrollbars=yes,resizable=yes,copyhistory=no,width=' + w + ',height=' + h + ',screenX=0,screenY=0,top=0,left=0');
}

function startDefgoNet(lang) {
    console.log(lang);
    openwindow4("https://www.defgo.net/defgolink_lang.asp?lang="+lang+"&s=1", 420, 700, "defgonet");
    return false;
}
$('.loginDefgo').click(function() {
    var lang = this.id;
    startDefgoNet(lang);
});

function clearFields(id) {
    $(':input[type=text]', id).val('');
    $(':input[type=email]', id).val('');
    $('textarea', id).val('');
}
//Validation:
$("#CheckifStudent").validate({
    submitHandler: function(form) {
        //show due to response time
        //  $("#trialMessage").fadeIn( 'slow' );
        form.submit();
        clearFields(this.id);
    }
});
$("#contactForm").validate({
    submitHandler: function(form) {
        //    $("#contactMessage").fadeIn( 'slow' );
        form.submit();
        clearFields(this.id);
    }
});
$("#offer").validate({
    submitHandler: function(form) {
        //    $("#requestDefgoMessage").fadeIn( 'slow' );
        form.submit();
        clearFields(this.id);
    }
});
$("#supportForm").validate({
    submitHandler: function(form) {
        //    $("#supportMessage").fadeIn( 'slow' );
        form.submit();
        clearFields(this.id);
    }
});
$("#studentForm").validate({
    submitHandler: function(form) {
        //show due to response time
        //  $("#studentMessage").fadeIn( 'slow' );
        form.submit();
        clearFields(this.id);
    }
});
$("#webinarForm").validate({
    submitHandler: function(form) {
        //    $("#webinarMessage").fadeIn( 'slow' );
        form.submit();
        clearFields(this.id);
    }
});
$("#defgoNet").validate({
    submitHandler: function(form) {
        //    $("#defgoNetMessage").fadeIn( 'slow' );
        form.submit();
        clearFields(this.id);
    }
});
$("#defgo1").validate({
    submitHandler: function(form) {
        //    $("#defgo1Message").fadeIn( 'slow' );
        form.submit();
        clearFields(this.id);
    }
});
$("#defgo2").validate({
    submitHandler: function(form) {
        //    $("#defgo2Message").fadeIn( 'slow' );
        form.submit();
        clearFields(this.id);
    }
});
$("#defgo3").validate({
    submitHandler: function(form) {
        //    $("#defgo3Message").fadeIn( 'slow' );
        form.submit();
        clearFields(this.id);
    }
});
$(function() {
    $('#dl-menu1').dlmenu({
        animationClasses: {
            classin: 'dl-animate-in-5',
            classout: 'dl-animate-out-5'
        }
    });
    $('#dl-menu2').dlmenu({
        animationClasses: {
            classin: 'dl-animate-in-5',
            classout: 'dl-animate-out-5'
        }
    });
    $('#dl-menu1-button').on("click", function() {
        $('#dl-menu2').dlmenu("closeMenu");
    });
    $('#dl-menu2-button').on("click", function() {
        $('#dl-menu1').dlmenu("closeMenu");
    });
});